import * as _ from 'lodash';
import { Store as VuexStore } from 'vuex';
import { NavigationGuard, Route } from 'vue-router';

import { Store } from '@/store';

export interface RedirectingScenario {
  conditions: RedirectingScenarioCondition[];
  redirectTo: string;
  afterSuccess: string | undefined;
  saveQuery: Boolean;
  saveParams: Boolean;
}

export enum RedirectingScenarioCondition {
  USER_IS_LOGGED_IN = 'user_is_logged_in',
  USER_IS_NOT_LOGGED_IN = 'user_is_not_logged_in',
  USER_HAS_ORGANIZATION = 'user_has_organization',
  USER_HAS_NO_ORGANIZATION = 'user_has_no_organization',
  USER_SELECTED_BUILDING = 'user_selected_building',
  USER_DID_NOT_SELECT_BUILDING = 'user_did_not_select_building',
  USER_ENABLED_SCENARIOS_FEATURE = 'user_enabled_scenarios_feature',
  USER_DID_NOT_ENABLE_SCENARIOS_FEATURE = 'user_did_not_enable_scenarios_feature',
}

export function getNavigationGuardByScenarios(
  scenarios: RedirectingScenario[],
  store: VuexStore<Store>,
): NavigationGuard {
  return (to: Route, from: Route, next: Function) => {
    for (const scenario of scenarios) {
      if (areConditionsMet(scenario.conditions, store)) {
        const query: any = (scenario.saveQuery)
          ? {
            query: {
              ...to.query,
            }
          }
          : {};
        if (scenario.afterSuccess != undefined) {
          query.query.after_success = scenario.afterSuccess;
        }
        const params = (scenario.saveParams)
          ? {
            params: {
              ...to.params,
            }
          }
          : {};
        next({
          name: scenario.redirectTo,
          ...query,
          ...params,
        });
        return;
      }
    }
    next();
  };
}

function areConditionsMet(
  conditions: RedirectingScenarioCondition[],
  store: VuexStore<Store>,
): boolean {
  const faultyCondition = _.find(
    conditions,
    (condition: RedirectingScenarioCondition) => !isConditionMet(condition, store),
  );
  return faultyCondition == undefined;
}

function isConditionMet(
  condition: RedirectingScenarioCondition,
  store: VuexStore<Store>,
): boolean {
  switch (condition) {
    case RedirectingScenarioCondition.USER_IS_LOGGED_IN:
      return isUserLoggedIn(store);
    case RedirectingScenarioCondition.USER_IS_NOT_LOGGED_IN:
      return !isUserLoggedIn(store);
    case RedirectingScenarioCondition.USER_HAS_NO_ORGANIZATION:
      return !doesUserHaveOrganization(store);
    case RedirectingScenarioCondition.USER_HAS_ORGANIZATION:
      return doesUserHaveOrganization(store);
    case RedirectingScenarioCondition.USER_SELECTED_BUILDING:
      return didUserSelectBuilding(store);
    case RedirectingScenarioCondition.USER_DID_NOT_SELECT_BUILDING:
      return !didUserSelectBuilding(store);
    case RedirectingScenarioCondition.USER_ENABLED_SCENARIOS_FEATURE:
      return didUserEnableScenariosFeature(store);
    case RedirectingScenarioCondition.USER_DID_NOT_ENABLE_SCENARIOS_FEATURE:
      return !didUserEnableScenariosFeature(store);
  }
}

function isUserLoggedIn(store: VuexStore<Store>): boolean {
  return _.get(store, 'state.user.currentUser.id', undefined) != undefined;
}

function doesUserHaveOrganization(store: VuexStore<Store>): boolean {
  return _.get(store, 'state.user.currentUser.organizationId', undefined) != undefined;
}

function didUserSelectBuilding(store: VuexStore<Store>): boolean {
  return _.get(store, 'state.user.currentBuildingId', undefined) != undefined;
}

function didUserEnableScenariosFeature(store: VuexStore<Store>): boolean {
  return _.get(store, 'state.user.isScenarioEnabled', false);
}
